import {
	Box,
	Button,
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Select,
	TextField,
	Typography,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

import SearchIcon from "@mui/icons-material/Search";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDataSources, getScenario, setState, getCustGrpRef } from "./editScenarioNewSlice";
import { sizes } from "./editScenarioNewUtils";

export default function SearchScenario() {
	const dispatch = useDispatch();
	const setupState = useSelector((store) => store.editScenarioNew);
	const loginState = useSelector((store) => store.login);
	const { countries, selectedCountry, countryID, scenarioName, predictionMethodPeriodList, previousYearPeriodList,DefaultInitialForecast } = setupState;
	const { globalSelectedCountryName,globalSelectedCountryID,} = loginState
	//const [minSelectableDate, setminFromDate] = useState(dayjs().startOf("month").toDate());
	//console.log(dayjs().startOf("month").toDate())
	const timeStamp = "2099-12-31 00:00";
	console.log(timeStamp)
	console.log(dayjs())
	const [fromDate, setFromDate] =  useState(null);
	const [toDate, setToDate] = useState(null);

	useEffect(() => {
		if(globalSelectedCountryID !== null){
		if(countryID !== globalSelectedCountryID)clearData();
		dispatch(setState("countryID", globalSelectedCountryID));
		}
	},[globalSelectedCountryID])

	useEffect(() => {
		if(globalSelectedCountryName !== null && globalSelectedCountryName !== ""){
		dispatch(setState("selectedCountry", globalSelectedCountryName));
		}
	},[globalSelectedCountryName])

	const handleCountryChange = (event) => {
		clearData();
		const countryName = event.target.value;
		const countryId = countries.find(
			(country) => country.countryName === countryName
		).countryID;
		console.log(countryId, countryName);
		dispatch(setState("selectedCountry", countryName));
		dispatch(setState("countryID", countryId));

		clearCountryDependents();
		getCountryDependents(countryId);
	};

	const clearCountryDependents = () => {
		dispatch(setState("dataSources", []));
		dispatch(setState("selectedDSs", []));
	};

	const getCountryDependents = (countryID) => {
		dispatch(getDataSources({ countryID }));
		dispatch(getCustGrpRef({countryID}));
	};

	const handleFromDate = (newValue) => {
		console.log("Edit_SearchScenario", newValue);
		//if (newValue <= toDate) {
			setFromDate(newValue);
		//}
	};

	const handleToDate = (newValue) => {
		console.log("Edit_SearchScenario", newValue);
		//if (newValue >= fromDate) {
			setToDate(newValue);
		//}
	};

	const changeDateFormat = (date) => {
		const year = date.year();
		const month =
			date.month() + 1 < 10 ? `0${date.month() + 1}` : date.month() + 1;
		const day = date.date() < 10 ? `0${date.date()}` : date.date();
		const time = "T00:00:00.000Z";
		const d = `${year}-${month}-${day}${time}`;
		return d;
	};
	const showMessage = (message, severity) => {
		dispatch(setState("message", message));
		dispatch(setState("severity", severity));
		dispatch(setState("messageOpen", true));
	};

	const handleSearch = () => {
		if(countryID == undefined ||countryID ==null || countryID == "") {
			showMessage("Please select country" , "info");
			return;
		}
		if(fromDate > toDate && toDate != null && fromDate != null) {
			showMessage("From Date cannot be greater than To Date" , "info");
			return;
		}
		dispatch(setState("editScenarioList", []));
		dispatch(setState("editScName", ""));
		dispatch(setState("editScID", ""));
		const fdate = "";
		const tdate = "";
		const obj = {
			countryId: countryID,
			scenario: "",
			fromDate: fromDate == null ? fdate : changeDateFormat(fromDate),
			toDate: toDate == null ? tdate : changeDateFormat(toDate)
		};
		console.log("SearchScenario", obj);
		dispatch(getScenario(obj));
	};
	const clearData = () =>{
		dispatch(setState("isLoading", false));
		dispatch(setState("sku_PG_Name", ""));
		dispatch(setState("productGroups", []));
		dispatch(setState("selectedPGs", []));
		dispatch(setState("selectedcustomerTypes", []));
		dispatch(setState("selectedCustType", ""));
		dispatch(setState("selectedCTCode", ""));
		dispatch(setState("selectedCL", ""));
		dispatch(setState("selectedCLID", ""));
		dispatch(setState("breakDowns", []));
		dispatch(setState("selectedBD", ""));
		dispatch(setState("breakDownTypes", []));
		dispatch(setState("selectedBDT", ""));
		dispatch(setState("selectedTL", "All"));
		dispatch(setState("selectedTLID", 0));
		dispatch(setState("customerName", ""));
		dispatch(setState("custsCGs", []));
		dispatch(setState("selectedCustsCGs", []));
		dispatch(setState("selectedDSs", []));
		dispatch(setState("selectedPDS", ""));
		dispatch(setState("selectedSKUBDM", ""));
		dispatch(setState("selectedScSTQ", "Disabled"));
		dispatch(setState("selectedScUB", "Disabled"));
    	dispatch(setState("selectedScModifySTQ", "Disabled"));
		dispatch(setState("selectedPG_SKU_ADSs",""));
		dispatch(setState("selectedPG_SKU_ADSsID", ""));
		dispatch(setState("DSAData", []));
		dispatch(setState("scDSA", []));
		dispatch(setState("scDSACopy", []));
		dispatch(setState("DSAIdString", ""));
		dispatch(setState("DSAIdStringPrev", ""));
		dispatch(setState("skuBreakdown", ""));
		dispatch(setState("customerBreakdownType", "Scenario SKUs"));
		dispatch(setState("customerBreakdown", "Internal 3 months"));
		dispatch(setState("MarketShareTimePeriod", ""));
		dispatch(setState("PreviousMarketShareTimePeriod", ""));
		dispatch(setState("scenarioName", ""));
		// api payload for scenario
		dispatch(setState("primaryDataSourceID", ""));
		dispatch(setState("minimumQuota", ""));
		dispatch(setState("comments", ""));
		dispatch(setState("lstScenarioCustomers", ""));
		dispatch(setState("lstScenarioCustomerGroups", ""));
		dispatch(setState("lstScenarioSKUs", ""));
		dispatch(setState("lstScenarioProducts", ""));
		dispatch(setState("scenarioDataSourceAlignment", []));
		dispatch(setState("scenarioStatus", ""));
		dispatch(setState("editScName", ""));
		dispatch(setState("editScenarioList", []));
		dispatch(setState("editScID", ""));
		dispatch(setState("editScDetails", null));
		dispatch(setState("message", ""));
		dispatch(setState("severity", ""));
		dispatch(setState("messageOpen", ""));
		dispatch(setState("selectedLinearTrend", predictionMethodPeriodList[0]?.name));
		dispatch(setState("selectedRunRate", predictionMethodPeriodList[0]?.name));
		dispatch(setState("selectedConsensus", predictionMethodPeriodList[0]?.name));
		dispatch(setState("selectedPreviousYear", previousYearPeriodList[0]?.name));
		dispatch(setState("selectedDefaultInitialForecast", DefaultInitialForecast[1]?.name));
		dispatch(setState("editScDSAData", []));
		dispatch(setState("localForecastAlignment", []));
		dispatch(setState("periodType", ""));
		dispatch(setState("emailNotification", false));
		dispatch(setState("criticalityId", ""));
		dispatch(setState("SafetyMargin",[]));
		//dispatch(setState("SafetyMargin", [{type: "Customer Group", safetyMargin: '', typeCode: "CustomerGroup"}],));
		dispatch(setState("selectedReferenceSKU", []));
		dispatch(setState("previousSelectedReferenceSKU", []));
		dispatch(setState("marketShareComparisonList", []));
		dispatch(setState("previousMarketShareComparisonList", []));
		dispatch(setState("selectedRows", []));
		dispatch(setState("marketShareGraphData", []));
		dispatch(setState("previousMarketShareGraphData", []));
		dispatch(setState("manually_defineMSList", []));
		dispatch(setState("quotaDeviationPercentage", 0));
		dispatch(setState("modificationDeviationPercentage", 0));
		dispatch(setState("scenarioExternalDataSource", []));
		dispatch(setState("scenarioExternalDataSourceSKU", []));
		dispatch(setState("refList",''));
		dispatch(setState("selectedCCID", 0));
		dispatch(setState("selectedCustCat", "All"));
		dispatch(setState("selectedCountry", ""));
		dispatch(setState("countryID", ""));
		dispatch(setState("createToDate", null));
		dispatch(setState("createFromDate", null));
		dispatch(setState("openScenarioPopUp", false));
		dispatch(setState("errorMessage", ""));
		dispatch(setState("errorList", []));
		dispatch(setState("section_Scenario_Parameteres", false));
		dispatch(setState("section_SKU", false));
		dispatch(setState("section_Customer", false));
		dispatch(setState("section_Datasources", false));
		dispatch(setState("section_Scenario_Settings", false));
		dispatch(setState("is_Refresh", true));
		dispatch(setState("isCustomerChanged", false));
	};

	return (
		<Box >
			<Grid container columns={12} justifyContent="space-between" alignItems="center" spacing={2} pb={1}
			//  maxWidth={"99%"}
			 >
				<Grid item xs={12} sm={3} md={4} lg={4.8}>
					<Box >
						<FormControl sx={{
									mt: 2,
									width: '100%',
								}}>
							<InputLabel 
							id="demo-simple-select-label">
								Country
							</InputLabel>
							<Select 
								labelId="demo-simple-select-label"
								id="demo-simple-select"
								value={selectedCountry}
								label="Country"
								onChange={handleCountryChange}>
								{countries.map((country, index) => {
									return (
										<MenuItem value={country.countryName} key={index}>
											{country.countryName}
										</MenuItem>
									);
								})}
							</Select>
						</FormControl>
					</Box>
				</Grid>

				<Grid item xs={12} sm={3} md={3} lg={3}>
					<Box
						sx={{
							mt: 1,
							width: '100%'
						}}
					>
						<LocalizationProvider dateAdapter={AdapterDayjs}>
							<DatePicker sx={{
							mt: 1,
							width: '100%'
						}}
								// minDate={minSelectableDate}
								label="From"
								value={fromDate}
								onChange={(newValue) => handleFromDate(newValue)}
								format="DD/MM/YYYY"
								renderInput={(params) => (
									<TextField 
										{...params}
										size="small"/>
								)}
							/>
						</LocalizationProvider>
					</Box>
				</Grid>
				<Grid item xs={12} sm={3} md={3} lg={3}>
					<Box
						sx={{
							mt: 1,
						}}
					>
						<LocalizationProvider dateAdapter={AdapterDayjs}>
							<DatePicker sx={{
							mt: 1,
							width: '100%'
						}}
								// minDate={minSelectableDate}
								label="To"
								value={toDate}
								onChange={(newValue) => handleToDate(newValue)}
								format="DD/MM/YYYY"
								renderInput={(params) => (
									<TextField
										{...params}
										size="small"
										sx={{ height: sizes.h35,width: sizes.w200 }}
									/>
								)}
							/>
						</LocalizationProvider>
					</Box>
				</Grid>
				<Grid item xs={12} sm={3} md={2} lg={1.2}>
					<Box>
						<Button
							startIcon={<SearchIcon sx={{ minWidth: 1,}}/>}
							sx={{
								bgcolor: "blue.main",
								color: "white.main",
								textTransform: "none",
								mt: 2,
								"&:hover": {
									bgcolor: "lightBlue.main",
								},
							}}
							onClick={handleSearch}
						>
							<Typography
								sx={{ variant: "button1", color: "white.main", fontWeight: 500, }}
							>
								Search
							</Typography>
						</Button>
					</Box>
				</Grid>
			</Grid>
		</Box>
	);
}
